/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/config/theme';

import { CopyrightNoticeProps } from './index';

/**
 * Base styles for the copyright notice component
 *
 * @param {CopyrightNoticeProps} props The copyright notice properties object
 * */
const baseStyles = (props: CopyrightNoticeProps) => css`
    margin: 0;
    display: inline-block;
    ${theme.typography.caption}
`;

/**
 * The copyright notice component styles
 *
 * @param {CopyrightNoticeProps} props The copyright notice properties object
 * */
export const styles = (props: CopyrightNoticeProps) => css`
    ${baseStyles(props)}
`;
